<template>
  <div :id="'drage' + taskId + uuid" class="dragess" @click="reset">
    <svg></svg>
  </div>
</template>

<script>
import * as d3 from "d3";
import dagreD3 from "dagre-d3";
export default {
  name: "drage",
  props: {
    taskId: {
      type: String,
      default: ""
    },
    taskType: {
      type: String
    },
    uuid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      fNode: "",
      tNode: "",
      initialScale: 1,
      rectWidth: 0,
      rectHeight: 0,
      timer: ""
    };
  },
  mounted() {
    this.setSvg();
    this.init();
    this.menu = document.createElement("div");
    this.menu.innerText = "删除";
    this.menu.className = "delete-menu";
    this.menu.style.cssText = `
      position: fixed;
      padding: 7px 10px;
      width: 80px;
      background: rgb(255, 255, 255);
      font-size: 12px;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.25);
      cursor: pointer;`;
    this.menu.addEventListener("click", e => {
      e.stopPropagation();
      e.preventDefault();
      this.deleteNode();
    });
    window.addEventListener("resize", this.resize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    setSvg() {
      let rect = document
        .querySelector("#drage" + this.taskId + this.uuid)
        .getBoundingClientRect();
      this.rectWidth = rect.width;
      this.rectHeight = rect.height;
      d3.select(`#drage${this.taskId}${this.uuid} svg`)
        .attr("width", this.rectWidth)
        .attr("height", this.rectHeight);
    },
    resize() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.setSvg();
        this.renderNode();
      }, 200);
    },
    init() {
      this.g = new dagreD3.graphlib.Graph()
        .setGraph({})
        .setDefaultEdgeLabel(function() {
          return {};
        });

      let svg = d3.select(`#drage${this.taskId}${this.uuid} svg`);
      let inner = svg.append("g");
      this.zoom = d3
        .zoom()
        .scaleExtent([0.75, 2.5])
        .on("zoom", () => {
          this.initialScale = d3.event.transform.k;
          inner.attr("transform", d3.event.transform);
        });
      svg.call(this.zoom);
    },
    reset() {
      let fnode = document.querySelector(".fNode");
      if (fnode) {
        this.renderNode();
      }
      let menu = document.querySelector(".delete-menu");
      if (menu) {
        document.body.removeChild(menu);
      }
    },
    renderNode() {
      let render = new dagreD3.render();
      let inner = d3.select(`#drage${this.taskId}${this.uuid} svg g`);
      render(inner, this.g);
      let width =
        (this.rectWidth - this.g.graph().width * this.initialScale) / 2;
      let height =
        (this.rectHeight - this.g.graph().height * this.initialScale) / 2;

      d3.select(`#drage${this.taskId}${this.uuid} svg`).call(
        this.zoom.transform,
        d3.zoomIdentity
          .translate(
            width === Infinity ? 1 : width,
            height === Infinity ? 1 : height
          )
          .scale(this.initialScale)
      );
      this.addEvent();
      this.addEvent2();
    },
    addEvent() {
      for (let node of document.querySelectorAll(".node")) {
        node.addEventListener("click", e => {
          e.stopPropagation();
          e.preventDefault();
          if (this.taskType === "watch" || this.taskType === "watch-only") {
            return;
          }
          let nodeId = "";
          let bool = true;
          let ele = e.target;
          while (bool) {
            if (/node/g.test(ele.className.animVal)) {
              nodeId = ele.id;
              bool = false;
            } else {
              ele = ele.parentNode;
            }
          }

          let fnode = document.querySelector(".fNode");
          if (fnode) {
            this.tNode = nodeId;
            this.setEdge();
          } else {
            node.classList.add("fNode");
            this.fNode = nodeId;
          }
        });
        node.addEventListener("contextmenu", e => {
          e.preventDefault();
          e.stopPropagation();
          if (this.taskType === "watch" || this.taskType === "watch-only") {
            return;
          }
          let nodeId = "";
          if (e.target.nodeName === "tspan") {
            nodeId = e.target.parentNode.parentNode.parentNode.parentNode.id;
          } else {
            nodeId = e.target.parentNode.id;
          }
          this.deleteId = nodeId;
          let menu = document.querySelector(".delete-menu");
          if (menu) {
            document.body.removeChild(menu);
          }
          this.menu.style.left = e.x + 10 + "px";
          this.menu.style.top = e.y + 10 + "px";
          document.body.appendChild(this.menu);
        });
      }
    },
    setNode(node) {
      this.g.setNode(node.nodeId, {
        label: node.jobName,
        id: node.nodeId,
        paddingX: 17,
        paddingY: 7
      });

      let newNode = this.g.node(node.nodeId);
      newNode.rx = 5;
      newNode.ry = 5;
      this.renderNode();
    },
    setEdge() {
      this.g.setEdge(this.fNode, this.tNode, {
        id: `${this.fNode}_${this.tNode}`,
        curve: d3.curveBasis,
        arrowhead: "vee"
      });
      if (!dagreD3.graphlib.alg.isAcyclic(this.g)) {
        this.g.removeEdge(this.fNode, this.tNode);
      }
      this.renderNode();
    },
    hasEdge(f, t) {
      let distance = dagreD3.graphlib.alg.dijkstra(this.g, t, () => {
        return 1;
      });
      return distance[f].distance === Infinity;
    },
    addEvent2() {
      for (let edge of document.querySelectorAll(".edgePath path")) {
        edge.addEventListener("contextmenu", e => {
          e.stopPropagation();
          e.preventDefault();
          if (this.taskType === "watch" || this.taskType === "watch-only") {
            return;
          }
          let con = e.target.parentNode.id;
          let [fNode, tNode] = con.split("_");
          this.g.removeEdge(fNode, tNode);
          this.renderNode();
        });
      }
    },
    deleteNode() {
      let menu = document.querySelector(".delete-menu");
      if (menu) {
        document.body.removeChild(menu);
      }
      this.g.removeNode(this.deleteId);
      this.renderNode();
      this.$emit("deleteNode", this.deleteId);
    }
  }
};
</script>

<style lang="scss">
.dragess {
  flex: 1 1 auto;
  background: #fff;
  overflow: hidden;
}

.node {
  &.fNode {
    rect {
      stroke: var(--blue);
    }
  }
  &.FAILED,
  &.KILLED {
    rect {
      stroke: var(--red);
      fill: var(--red);
    }
    text {
      fill: #fff;
    }
  }
  &.SUCCEEDED {
    rect {
      stroke: var(--green);
      fill: var(--green);
    }
    text {
      fill: #fff;
    }
  }
  &.RUNNING {
    rect {
      stroke: var(--blue);
      fill: var(--blue);
    }
    text {
      fill: #fff;
    }
  }
  rect {
    stroke: #2f2f2f;
    fill: #f0f2f5;
    stroke-width: 2px;
    cursor: pointer;
  }

  text {
    font-weight: 300;
    user-select: none;
    cursor: pointer;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serf;
    fill: #0a0b0b;
    font-size: 16px;
  }
}
.edgePath {
  path {
    cursor: not-allowed;
    stroke: #2f2f2f;
    fill: #2f2f2f;
    stroke-width: 2px;
  }
  &:hover {
    path {
      stroke: var(--blue);
      fill: var(--blue);
    }
  }
}
</style>
